!(function (e) {
    e.fn.niceSelect = function (t) {
        function a(t) {
            t.after(
                e("<div></div>")
                    .addClass("nice-select")
                    .addClass(t.attr("class") || "")
                    .addClass(t.attr("disabled") ? "disabled" : "")
                    .attr("tabindex", t.attr("disabled") ? null : "0")
                    .html('<span class="current"></span><ul class="list"></ul>')
            );
            var a = t.next(),
                s = t.find("option"),
                i = t.find("option:selected");
            a.find(".current").html(i.data("display") || i.text()),
                s.each(function (t) {
                    var s = e(this),
                        i = s.data("display");
                    a.find("ul").append(
                        e("<li></li>")
                            .attr("data-value", s.val())
                            .attr("data-display", i || null)
                            .addClass("option" + (s.is(":selected") ? " selected" : "") + (s.is(":disabled") ? " disabled" : ""))
                            .html(s.text())
                    );
                });
        }
        if ("string" == typeof t)
            return (
                "update" == t
                    ? this.each(function () {
                          var t = e(this),
                              s = e(this).next(".nice-select"),
                              i = s.hasClass("open");
                          s.length && (s.remove(), a(t), i && t.next().trigger("click"));
                      })
                    : "destroy" == t
                    ? (this.each(function () {
                          var t = e(this),
                              a = e(this).next(".nice-select");
                          a.length && (a.remove(), t.css("display", ""));
                      }),
                      0 == e(".nice-select").length && e(document).off(".nice_select"))
                    : console.log('Method "' + t + '" does not exist.'),
                this
            );
        this.hide(),
            this.each(function () {
                var t = e(this);
                t.next().hasClass("nice-select") || a(t);
            }),
            e(document).off(".nice_select"),
            e(document).on("click.nice_select", ".nice-select", function (t) {
                var a = e(this);
                e(".nice-select").not(a).removeClass("open"), a.toggleClass("open"), a.hasClass("open") ? (a.find(".option"), a.find(".focus").removeClass("focus"), a.find(".selected").addClass("focus")) : a.focus();
            }),
            e(document).on("click.nice_select", function (t) {
                0 === e(t.target).closest(".nice-select").length && e(".nice-select").removeClass("open").find(".option");
            }),
            e(document).on("click.nice_select", ".nice-select .option:not(.disabled)", function (t) {
                var a = e(this),
                    s = a.closest(".nice-select");
                s.find(".selected").removeClass("selected"), a.addClass("selected");
                var i = a.data("display") || a.text();
                s.find(".current").text(i), s.prev("select").val(a.data("value")).trigger("change");
            }),
            e(document).on("keydown.nice_select", ".nice-select", function (t) {
                var a = e(this),
                    s = e(a.find(".focus") || a.find(".list .option.selected"));
                if (32 == t.keyCode || 13 == t.keyCode) return a.hasClass("open") ? s.trigger("click") : a.trigger("click"), !1;
                if (40 == t.keyCode) {
                    if (a.hasClass("open")) {
                        var i = s.nextAll(".option:not(.disabled)").first();
                        i.length > 0 && (a.find(".focus").removeClass("focus"), i.addClass("focus"));
                    } else a.trigger("click");
                    return !1;
                }
                if (38 == t.keyCode) {
                    if (a.hasClass("open")) {
                        var o = s.prevAll(".option:not(.disabled)").first();
                        o.length > 0 && (a.find(".focus").removeClass("focus"), o.addClass("focus"));
                    } else a.trigger("click");
                    return !1;
                }
                if (27 == t.keyCode) a.hasClass("open") && a.trigger("click");
                else if (9 == t.keyCode && a.hasClass("open")) return !1;
            });
        var s = document.createElement("a").style;
        return (s.cssText = "pointer-events:auto"), "auto" !== s.pointerEvents && e("html").addClass("no-csspointerevents"), this;
    };
})(jQuery),
    $(document).ready(function (e) {
        if (
            ($("body").on("change", ".filter_check", function (e) {
                e.preventDefault(), (window.location = $(this).parent().find("a").attr("href"));
            }),
            $(".shopify-currency-form select").on("change", function () {
                $(this).parents("form").submit();
            }),
            $(".currecyBox").niceSelect(),
            (Shopify.queryParams = {}),
            location.search.length)
        )
            for (var t, a = 0, s = location.search.substr(1).split("&"); a < s.length; a++) (t = s[a].split("=")).length > 1 && (Shopify.queryParams[decodeURIComponent(t[0])] = decodeURIComponent(t[1]));
        var i;
        function o() {
            $.get("/cart?view=mini", function (e) {
                $("#crt").html(e), $("#crt").removeClass("loading");
            }),
                $("#cart").length &&
                    setTimeout(function () {
                        $.get("/cart?view=page", function (e) {
                            $("#cart").html(e), $("#cart").removeClass("loading");
                        });
                    }, 1500);
        }
        $(".sortCol a").on("click", function (e) {
            e.preventDefault(), (Shopify.queryParams.sort_by = jQuery(this).attr("href")), (location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, "%20"));
        }),
            $(".goToTop").on("click", function (e) {
                e.preventDefault(), $("html, body").animate({ scrollTop: 0 }, "slow");
            }),
            $(window).scroll(function () {
                var e;
                $(window).scrollTop() > 100 ? $(".goToTop").fadeIn() : $(".goToTop").fadeOut();
            }),
            $(window).scrollTop() > 100 ? $(".goToTop").fadeIn() : $(".goToTop").fadeOut(),

            $(".cartOuter").on("click", function (e) {
                e.preventDefault(),
                    setTimeout(function () {
                        $("body").addClass("cartOpen"), $(".fullPage").addClass("witmenu");
                    }, 50);
            }),
            $("body").on("click", ".quick-cart-details .adjust", function () {
                var e = $(this).parent().find("input");
                var t = parseInt(e.val());
                if (($(this).hasClass("plus") ? (t += 1) : (t -= 1), 0 == t)) return !1;
                e.val(t), $("#crt").addClass("loading");
                var a = parseInt(e.attr("data-id"));
                $.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    data: "updates[" + a + "]=" + t,
                    dataType: "json",
                    error: function (e, t, a) {
                        var s = $.parseJSON(e.responseText);
                        alert(s.description), $("#crt").removeClass("loading");
                    },
                }).done(function (e) {
                    o(),
                        $.getJSON("/cart.js", function (e) {
                            $(".itemCount").text(e.item_count);
                        }),
                        $("#crt").removeClass("loading");
                });
            }),
            $("body").on("click", ".addtocart", function (e) {
                e.preventDefault();
                var t = $(this).closest("form").find(".collection_swatch .swatch input:radio");
                $(this).closest("form").find(".swatch-msg").remove();
                var a = !1;
                if (
                    ($(t).each(function (e, t) {
                        var s = $(this).data("product_id");
                        0 == $("input:radio[data-product_id=" + s + "]:checked").length && (a = !0);
                    }),
                    1 == a)
                )
                    $(this).after('<p class="swatch-msg">Please select your size</p>');
                else {
                    var s = $(this);
                    var i = $(this).data("btn-text");
                    var n = $(this).closest("form");
                    console.log(n.serialize()),
                        s.attr("disabled", "disabled"),
                        s.val("Adding..."),
                        n.find(".error").remove(),
                        pintrk("track", "addtocart"),
                        $.ajax({
                            type: "POST",
                            url: "/cart/add.js",
                            data: n.serialize(),
                            dataType: "json",
                            error: function (e, t, a) {
                                var o = $.parseJSON(e.responseText);
                                n
                                    .append('<p class="error">' + o.description + "</p>")
                                    .find(".error")
                                    .fadeIn()
                                    .delay(4e3)
                                    .fadeOut(),
                                    s.val(i),
                                    s.removeAttr("disabled");
                            },
                        }).done(function (e) {
                            o(),
                                $.getJSON("/cart.js", function (e) {
                                    $(".itemCount").text(e.item_count);
                                }),
                                s.val(i),
                                s.removeAttr("disabled"),
                                $(".productGrid .productItem").removeClass("qvopen"),
                                $("body").addClass("cartOpen"),
                                $(".fullPage").addClass("witmenu");
                        });
                }
            }),
            $("body").on("click", ".collection_swatch .swatch-element.available", function (e) {
                e.preventDefault();
                var t = $(this).attr("data-variant-id");
                var a = $(this);
                var s = $(this).closest("form");
                a.attr("disabled", "disabled"),
                    pintrk("track", "addtocart"),
                    $(a).find(".add-success").addClass("go_to_cirkle"),
                    setTimeout(function () {
                        $(a).find(".add-success").addClass("add_true");
                    }, 800),
                    $.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        data: { quantity: 1, id: t },
                        dataType: "json",
                        error: function (e, t, i) {
                            var o = $.parseJSON(e.responseText);
                            s
                                .append('<p class="error">' + o.description + "</p>")
                                .find(".error")
                                .fadeIn()
                                .delay(4e3)
                                .fadeOut(),
                                a.removeAttr("disabled");
                        },
                    }).done(function (e) {
                        function t() {
                            $("body").hasClass("cartOpen")
                                ? ($(a).find(".add-success").removeClass("go_to_cirkle"), $(a).find(".add-success").removeClass("add_true"))
                                : setTimeout(function () {
                                      t();
                                  }, 1e3);
                        }
                        t(),
                            o(),
                            $.getJSON("/cart.js", function (e) {
                                $(".itemCount").text(e.item_count);
                            }),
                            a.removeAttr("disabled"),
                            $(".productGrid .productItem").removeClass("qvopen"),
                            $("body").addClass("cartOpen"),
                            $(".fullPage").addClass("witmenu");
                    });
            }),
            $("#crt").on("click", "a.remove_item", function (e) {
                $("#crt").addClass("loading"), e.preventDefault();
                var t = $(this).data("id");
                Shopify.changeItem(t, 0, function (e) {
                    $(".itemCount").text(e.item_count),
                        e.item_count
                            ? o()
                            : ($(".itemCount").text("0"),
                              $("#crt").empty(),
                              $("#crt").append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>'),
                              $("#crt").removeClass("has-item"),
                              $("#crt").removeClass("loading"));
                });
            }),
            $("#mc-embedded-subscribe-form-footer").on("submit", function (e) {
                e.preventDefault();
                var t = !0;
                var a = $(this);
                a.find(".err-msg").remove();
                var s = $(this).find("#Email");
                var i = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                if (
                    ("" != s.val().trim() && i.test(s.val())
                        ? (s.removeAttr("style"), s.parent().find(".err-msg").remove())
                        : (s.css("border-bottom", "1px solid red"), s.parent().append('<p class="err-msg">Please enter valid e-mail...</p>'), (t = !1)),
                    0 == t)
                )
                    return !1;
                $.ajax({
                    type: "GET",
                    url: "//doyoueven.us8.list-manage.com/subscribe/post-json?u=1fd9672b21ced3002e6760e59&id=677155b6f5&c=?",
                    data: a.serialize(),
                    cache: !1,
                    dataType: "jsonp",
                    jsonp: "c",
                    contentType: "application/json; charset=utf-8",
                    error: function (e) {},
                    success: function (e) {
                        if ("success" != e.result) {
                            var t = e.msg || "Sorry. Unable to subscribe. Please try again later.";
                            e.msg && e.msg.indexOf("already subscribed") >= 0 ? (t = "You're already subscribed. Thank you.") : $("#mce-responses").text(t).show();
                        } else $("#mce-responses").text("Thank you for submitting!").show(), a[0].reset();
                    },
                });
            }),
            $.cookie("wishlists") &&
                $(".wishlistBtn").each(function () {
                    var e = $(this).attr("data-pid");
                    var t = $.cookie("wishlists");
                    (t = t.split(",")), -1 != $.inArray(e, t) && $(this).addClass("added");
                }),
            $(".wishlistBtn").on("click", function (e) {
                e.preventDefault();
                var t = $(this).attr("data-pid");
                var a;
                if ($.cookie("wishlists"))
                    if (((a = (a = $.cookie("wishlists")).split(",")), -1 != $.inArray(t, a))) {
                        var a;
                        var s = (a = a.filter(function (e) {
                            return e !== t;
                        })).toString();
                        $(this).removeClass("added"), $.cookie("wishlists", s, { expires: 9999, path: "/" });
                    } else {
                        a.push(t);
                        var s = a.toString();
                        $.cookie("wishlists", s, { expires: 9999, path: "/" }), $(this).addClass("added");
                    }
                else $.cookie("wishlists", t, { expires: 9999, path: "/" }), $(this).addClass("added");
            }),
            $.ajax({
                url: "//extreme-ip-lookup.com/json",
                type: "POST",
                dataType: "jsonp",
                success: function (e) {
                    "AU" === e.countryCode ? $('.afterPayAuOnly, .site-footer__links a[href="/pages/afterpay"]').show() : $(".mainFooterBottom").addClass("text-center");
                },
            }),
            $("body").on("click", ".qtyBox .adjust", function () {
                var e = parseInt($(this).parent().find("input").val());
                $(this).hasClass("plus") ? (e += 1) : (e -= 1), 0 == e && (e = 1), $(this).parent().find("input").val(e);
            }),
            //$(".offerSliderOuter").slick({ infinite: !0, autoplay: !0, autoplaySpeed: 7e3, arrows: !0 }),
            //$(".mainSlider").slick({ infinite: !0, arrows: !0, autoplay: !0, fade: !0 }),
            $(".toggleItem").on("click", function (e) {
                var t = "+" == $(this).text() ? "-" : "+";
                $(this).text(t), $(this).parent().next("ul").slideToggle();
            }),
            $(".mobileNav button").click(function (e) {
                setTimeout(function () {
                    $("body").addClass("menuOpen"), $(".fullPage").addClass("witmenu");
                }, 50);
            }),
            $(".openFilter").click(function (e) {
                setTimeout(function () {
                    $("body").addClass("filterOpen"), $(".fullPage").addClass("witmenu");
                }, 50);
            }),
            $("body").on("click", ".fullPage.witmenu, .closemenu, .closecart", function (e) {
                e.preventDefault(), $("body").removeClass("menuOpen"), $(".fullPage").removeClass("witmenu"), $("body").removeClass("filterOpen"), $("body").removeClass("cartOpen");
            });
        var n = function () {
            var e;
            $(window).scrollTop() > 10 ? ($(".mainHeader ").addClass("stickyClass"), $(".mainHeader .topBar").slideUp()) : ($(".mainHeader").removeClass("stickyClass"), $(".mainHeader .topBar").slideDown());
        };
        function r() {
            $(".popupBox").removeClass("slideInDown"), $(".popupBox").addClass("slideOutUp"), $(".popupOverlay").fadeOut("slow");
        }
        function l(e) {
            $(".popupBox").addClass("slideInDown"), $(".popupBox").removeClass("slideOutUp"), $(".popupOverlay." + e).fadeIn("slow");
        }
        n(),
            $(window).scroll(function () {
                n();
            }),
            $("body").on("click", ".popupinfo, .openPopup", function (e) {
                var t;
                e.preventDefault(), l($(this).attr("href"));
            }),
            $("body").on("click", ".cls_popup", function (e) {
                e.preventDefault(), r();
            }),
            $(document).keyup(function (e) {
                27 == e.keyCode && r();
            }),
            (window.onclick = function (e) {
                $(e.target).hasClass("popupOverlay") && r(), $(e.target).closest(".productItem").length || $(".productGrid .productItem").removeClass("qvopen");
            });
            //$(".featured_blog").slick({ dots: !0, infinite: !0, arrows: !0, speed: 300, slidesToShow: 1, fade: !0, autoplay: !0 });
        var c = document.getElementById("myVideo1");
        $("#myVideo1").click(function () {
            return $(this).hasClass("auto") ? (c.play(), $(this).removeClass("auto")) : (c.pause(), $(this).addClass("auto")), !1;
        }),
            $("#footerNewsletter").on("submit", function (e) {
                e.preventDefault();
                var t = !0;
                var a = $(this);
                var s = a.find("input[type='email']").val().trim();
                var i = a.find('input[type="email"]');
                var o = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                if (($(".err-msg").remove(), "" != i.val().trim() && o.test(i.val()) ? i.parent().find(".err-msg").remove() : (i.parent().append('<p class="err-msg">Please enter valid e-mail.</p>'), (t = !1)), t)) {
                    var n;
                    var r = {
                        async: !0,
                        crossDomain: !0,
                        url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
                        method: "POST",
                        headers: { "content-type": "application/x-www-form-urlencoded", "cache-control": "no-cache" },
                        data: { g: a.find('[name="g"]').val(), email: s, Locale: "En", $source: "Origin Artical", $fields: "$source, Locale" },
                    };
                    $.ajax(r).done(function (e) {
                        a.hide(), a.parent().append("<span class='successMsg'>Thanks! Please confirm your email for subsription :)</span>");
                    });
                }
            }),
            $("#cart").length &&
                setTimeout(function () {
                    $.get("/cart?view=page", function (e) {
                        $("#cart").html(e), $("#cart").removeClass("loading");
                    });
                }, 1500),
            $("#size-guide-modal").length > 0
                ? $(".product__size-guide-link").on("click", function (e) {
                      e.preventDefault(),
                          $.magnificPopup.open({
                              items: { src: "#size-guide-modal" },
                              type: "inline",
                              fixedContentPos: !1,
                              fixedBgPos: !0,
                              overflowY: "auto",
                              closeBtnInside: !0,
                              preloader: !1,
                              midClick: !0,
                              removalDelay: 300,
                              mainClass: "my-mfp-slide-bottom",
                          });
                  })
                : $(".product__size-guide-link").attr("target", "_blank");
    });
//# sourceMappingURL=/s/files/1/0669/7933/t/159/assets/custom_script.js.map?v=1627385869
